import React, { useEffect } from 'react'
import {
  Button,
  Flex,
  Icon,
  Input,
  InputGroup,
  InputLeftAddon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useDisclosure,
} from '@chakra-ui/react'
import { FaSearch } from 'react-icons/fa'
import { useForm } from 'react-hook-form'
import { useProducao360Context } from '../../../contexts/Producao360Provider'
import { api } from '../../../services/api'

async function listarCaricatura360() {
  const res = api.get('/site/v2/fluxo-layout/listar-ilustracoes-compre-ganhe')

  return res.data
}

export const ModalInicialFiltro = ({ setIsCompreGanhe, isCompreGanhe }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()
  const form = useForm()
  const { setFormValues, query } = useProducao360Context()
  const { register, handleSubmit, setValue } = form

  const { isLoading, isRefetching, data } = query

  async function handleSubmitFilter(data, compre_ganhe) {
    const { pedido, pendente } = data

    setFormValues({ pedido, pendente, compre_ganhe })

    onClose()
  }

  function compreGanheOpen() {
    setIsCompreGanhe(true)
    setValue('compre_ganhe', 1)
    setFormValues({ compre_ganhe: 1 })

    onClose()
  }

  useEffect(() => {
    onOpen()
  }, [])

  return (
    <>
      <Modal size="4xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <Flex alignItems="flex-end" gap={5}>
              <Flex alignItems="flex-end" gap={5} w="full" maxW="626px" mx="auto">
                <InputGroup size="sm">
                  <InputLeftAddon children="Pesquisar pedido" as="label" htmlFor="pedido" />
                  <Input id="pedido" type={'pedido'} placeholder={'Pedido'} {...register('pedido')} />
                </InputGroup>

                <InputGroup size="sm">
                  <InputLeftAddon children="Pendente" as="label" htmlFor="pendente" />
                  <Select id="pendente" size="sm" borderLeftRadius={0} placeholder="Selecione" {...register('pendente')}>
                    <option value="true">Pendente</option>
                    <option value="false">Não pendente</option>
                  </Select>
                </InputGroup>
              </Flex>
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button
              onClick={compreGanheOpen}
              fontSize="12px"
              fontWeight="normal"
              size="sm"
              maxW="147px"
              bgColor="#378BBF"
              w="100%"
              colorScheme="blue"
              leftIcon={<Icon as={FaSearch} />}
              mr={2}
            >
              Listar Compre Ganhe
            </Button>

            <Button
              onClick={() => handleSubmit(handleSubmitFilter)()}
              fontSize="12px"
              fontWeight="normal"
              size="sm"
              maxW="147px"
              bgColor="#378BBF"
              w="100%"
              type="submit"
              colorScheme="blue"
              leftIcon={<Icon as={FaSearch} />}
              isLoading={isLoading || isRefetching}
            >
              Filtrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
